import { RefObject, useEffect } from 'react'

export function useAutomaticFocus(
  ref: RefObject<HTMLInputElement | undefined>,
) {
  useEffect(() => {
    ref.current?.focus()
  }, [ref])
}
